// extracted by mini-css-extract-plugin
export default {"container":"SessionLogout__container","title":"SessionLogout__title","message":"SessionLogout__message","loginButton":"SessionLogout__loginButton"};